import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-old-about',
  templateUrl: './old-about.component.html',
  styleUrls: ['./old-about.component.scss']
})
export class OldAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
